export default "__VITE_ASSET__22c840e4__"